import e from "../managers/braze-instance.js";
import dt from "./utils/push-utils.js";
export function isPushPermissionGranted() {
  if (e.rr()) return dt.isPushPermissionGranted();
}
